// @ts-nocheck



import React, { Component } from 'react';
import styled from 'styled-components';

import { Section, SectionTitle } from '../../../components/layout';
import OperationLimitGroup from './OperationLimitGroup';


const SectionContent = styled.div.withConfig({ displayName: "TimeLimits__SectionContent", componentId: "sc-h9qce3-0" })(["padding:16px;"]);









export default class TimeLimits extends Component {
  render() {
    const { orgUnitId } = this.props;

    return (
      <>
        <Section>
          <SectionTitle divider>Должностные лица</SectionTitle>
          <SectionContent>
            <OperationLimitGroup orgUnitId={orgUnitId} type="employee" />
          </SectionContent>
        </Section>
        <Section>
          <SectionTitle divider>ОВБ</SectionTitle>
          <SectionContent>
            <OperationLimitGroup orgUnitId={orgUnitId} type="ovb" />
          </SectionContent>
        </Section>
        <Section>
          <SectionTitle divider>Службы</SectionTitle>
          <SectionContent>
            <OperationLimitGroup orgUnitId={orgUnitId} type="orgUnit" />
          </SectionContent>
        </Section>
      </>);

  }
}
